import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";

import { BackButton } from "../../components/buttons/backButton/BackButton";
import { Button } from "../../components/buttons/Button";
import { Card } from "../../components/card/Card";
import { Divider } from "../../components/dividers/Divider";
import { TwoColumnPageLayout } from "../../components/pageLayout/TwoColumnPageLayout";
import { ValidationMessage } from "../../components/validationMessage/ValidationMessage";
import { ModelState } from "../../interfaces/modelState";
import styles from "./MutationLayout.module.scss";

interface Props {
  loading: boolean;
  modelState: ModelState | null;
  title: string;
  CardContent: ReactNode;
  InfoContent: ReactNode;
  handleSubmit: () => Promise<void>;
  canSubmitForm: boolean;
}

export const MutationLayout = ({
  loading,
  modelState,
  title,
  CardContent,
  InfoContent,
  handleSubmit,
  canSubmitForm,
}: Props) => {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };
  return (
    <>
      <div className={styles.mutationLayout__header}>
        <BackButton id="button_cancel_header">Wijziging annuleren</BackButton>
      </div>

      <Divider type="horizontal" />

      <div className={styles.mutationLayout__error}>
        <ValidationMessage id="global" modelState={modelState} property="Global" />
      </div>

      <TwoColumnPageLayout
        LeftColumn={
          <div className={styles.mutationLayout__columnLeft}>
            <Card>
              <h2>{title}</h2>
              {CardContent}
            </Card>
          </div>
        }
        RightColumn={
          <div className={styles.mutationLayout__columnRight}>
            <div className={styles.mutationLayout__infoWrapper}>{InfoContent}</div>

            <div className={styles.mutationLayout__buttonsWrapper}>
              <Button
                id="button_cancel_side"
                disabled={loading}
                leading={<i className={`icon icon-cross`} />}
                type="outlined"
                onClick={handleGoBack}
              >
                Wijziging annuleren
              </Button>
              <Button
                id="button_submit_side"
                loading={loading}
                leading={<i className={`icon icon-check`} />}
                type="primary"
                onClick={handleSubmit}
                disabled={!canSubmitForm}
              >
                Wijziging opslaan
              </Button>
            </div>
          </div>
        }
      />
    </>
  );
};
